export default function getTwoSymbols(input:number):string {
    if(input === undefined) return '';
    return (input + 1).toString().padStart(2, '0');
}